import { filter } from 'rxjs/operators';
import { UserId } from '@streem/domain-id';
export function participantFilterProvider(userId) {
    return filter((participant) => {
        if (!userId) {
            return false;
        }
        return userId.compare(new UserId(participant.userSid));
    });
}
//# sourceMappingURL=participant_filter_provider.js.map